import React, { lazy } from 'react';
import { Redirect, Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { TranslatorProvider } from 'react-translate';
import { hotjar } from 'react-hotjar';
import markerSDK from '@marker.io/browser';
import classnames from 'classnames';
import translationsEn from './i18n/en.json';
import translationsDe from './i18n/de.json';

import PublicRoute from './components/PublicRoute';
import history from './helpers/history';

import LoadingScreen from './components/core/components/LoadingScreen/LoadingScreen';
import { AVAILABLE_LANGUAGES, LANGUAGE_CODES } from './constants';

import SignUpRoute from './containers/SignUpRoute';
import { useInitMixpanel } from './hooks';

// lazy components
const SignUpPage = lazy(() => import('./containers/Authorization/SignUpPage'));
const ConfirmEmailPage = lazy(() => import('./components/registration/core/ConfirmEmailPage'));
const RegistrationStepList = lazy(() => import('./containers/RegistrationStepList'));
const GetStartedPage = lazy(() => import('./components/registration/core/GetStartedPage'));

const newAppUrl = process.env.REACT_APP_NEW_URL;

const widget = async () => {
  /*const destination = process.env.REACT_APP_MARKER_DESTINATION;
  if (!destination) {
    throw new Error('REACT_APP_MARKER_DESTINATION not set in env');
  }

  return markerSDK.loadWidget({
    destination,
    source: 'snippet',
    beta: {
      sessionReplay: true,
    },
  });*/
};

const InitMixpanel = () => {
  useInitMixpanel();

  return null;
};

const hjid = +(process.env.REACT_APP_HOTJAR_ID ?? '');
const hjsv = +(process.env.REACT_APP_HOTJAR_VERSION ?? '');

class Routes extends React.Component {
  constructor(props) {
    super(props);

    this.widgetInstance;
    this.widget = widget;
  }

  componentDidMount() {
    const { user } = this.props;

    (hjid && hjsv) && hotjar.initialize(hjid, hjsv);

    user && (this.widgetInstance = this.widget());
  }

  componentDidUpdate() {
    const { user } = this.props;
    user
      ? (this.widgetInstance = this.widget())
      : this.widgetInstance && this.widgetInstance.then((data) => data.hide());
  }

  render() {
    const {
      user,
      isAuthenticated,
    } = this.props;
    const state = user?.state ?? '';
    const lang = LANGUAGE_CODES[user?.language ?? 'English'] || navigator.language.toString().slice(0, 2);

    if (AVAILABLE_LANGUAGES.indexOf(lang) === -1) {
      const newLang = AVAILABLE_LANGUAGES[0];
      return <Redirect to={`/${newLang}/sign-up`} />;
    }

    // Redirect authenticated non-onboarding users to the new app
    if (isAuthenticated && state !== 'ONBOARDING') {
      window.location.href = newAppUrl;
      return null;
    }

    let translations;

    switch (lang) {
      case 'en':
        translations = translationsEn;
        break;
      case 'de':
        translations = translationsDe;
        break;
      default:
        translations = translationsEn;
    }

    return (
      <TranslatorProvider translations={translations}>
        <Router history={history}>
          <InitMixpanel />
          <div className={classnames('root-wrapper', { 'german-lan': lang === 'de' })}>
            <LoadingScreen />
            <Switch>
              <PublicRoute
                lazy
                path={`/${lang}/sign-up`}
                component={SignUpPage}
                lang={lang}
              />
              <PublicRoute
                lazy
                path={`/${lang}/verify-email/:token`}
                component={ConfirmEmailPage}
                lang={lang}
              />
              <SignUpRoute
                lazy
                path={`/${lang}/lets-go`}
                component={GetStartedPage}
                lang={lang}
              />
              <SignUpRoute
                lazy
                path={`/${lang}/sign-up-steps`}
                component={RegistrationStepList}
                lang={lang}
              />
              <Redirect to={`/${lang}/${isAuthenticated ? 'lets-go' : 'sign-up'}`} />
            </Switch>
          </div>
        </Router>
      </TranslatorProvider>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(Routes);
